import { useApiQuery } from '@/modules/common';

import { ModelRestriction, ModelsAttributes } from '../types';

export function useModelAttributes() {
  const { data, isFetching } = useApiQuery<ModelsAttributes>(
    '/models/attributes',
    {
      queryKey: ['modelsAttributes'],
      initialData: {
        colors: [],
        types: [],
        genders: [],
        fileNames: [],
        sizes: [],
      },
    }
  );

  const { data: restrictions, isFetching: isRestrictionsFetching } =
    useApiQuery<ModelRestriction[]>('/models/restrictions', {
      queryKey: ['modelRestrictions'],
      initialData: [],
    });

  return {
    data,
    isFetching,
    restrictions,
    isRestrictionsFetching,
  } as const;
}
